module.exports = __webpack_public_path__ + "_/img/lineten.5aeb40ca.png";